import { FC } from 'react'
import { UseQueryResult } from 'react-query'
import { CondicaoCatalogo } from '../../formularios/core/condicao/catalogo'
import { TableErrorState } from '../../../../components/Table/TableStates'
import { DetailPanel } from '../../../../components/DetailPanel/DetailPanel'
import { ComparacaoProtocolo as Comparacao } from '../core/_models'
import { ComparacaoProtocolo } from '../comparacao/ComparacaoProtocolo'

type Props = {
  comparacao: UseQueryResult<Comparacao>
  catalogo?: CondicaoCatalogo
}

/**
 * Corpo do card das telas de comparação (protocolo da empresa e modelo da plataforma): carregando,
 * erro (com "Tentar de novo") ou o diff entre as versões (`ComparacaoProtocolo`).
 */
export const ComparacaoConteudo: FC<Props> = ({ comparacao, catalogo }) => (
  <div className='card-body' aria-live='polite'>
    {comparacao.isError ? (
      <TableErrorState
        title='Não foi possível carregar a comparação.'
        onRetry={comparacao.refetch}
      />
    ) : comparacao.isLoading ? (
      <DetailPanel isLoading loadingLabel='Carregando comparação…' />
    ) : (
      <ComparacaoProtocolo comparacao={comparacao.data} catalogo={catalogo} />
    )}
  </div>
)
